(() => {
  function loadMore(event) {
    if (event.target.nodeName !== 'A') return;
    const POSTS_WRAPPER = '.js-posts';
    const TRIGGER_WRAPPER = '.js-next';
    const url = event.target.href;

    event.preventDefault();
    console.log(url)
    try {
      fetch(url)
        .then(result => result.text())
        .then(result => Promise.resolve(result.replace( /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "" )))
        .then(function(data) {
          var results = document.createElement('div');
          results.innerHTML = data;

          var foundPosts = results.querySelector(POSTS_WRAPPER);
          var currentPosts = document.querySelector(POSTS_WRAPPER);
          if (foundPosts && currentPosts) {
            currentPosts.innerHTML += foundPosts.innerHTML;
          }

          trigger = results.querySelector(TRIGGER_WRAPPER );
          if (trigger) {
            document.querySelector(TRIGGER_WRAPPER).appendChild(trigger);
          }

          history.pushState({}, '', url);
        })
        .catch(function(e) {
          window.location.href = url;
        });

      event.currentTarget.removeChild(event.target);
    } catch (e) {}
  }

  const nextElement = document.querySelector('.js-next');
  if (nextElement) {
    nextElement.addEventListener('click', loadMore)
  }

  let clicked = null;
  document.addEventListener('touchstart', function(e) {
    const preview = e.target.closest('.c-preview');
    if (clicked) {
      clicked.classList.remove('hover')

      if (!preview) clicked = null;
    }
    if (!preview) return;

    if (clicked && clicked == preview) return;
    preview.classList.add('hover');
    clicked = preview;
    event.preventDefault();
  }, { passive: false })

  Array.from(document.querySelectorAll('.c-plyr')).forEach(el => {
    new Plyr('[plyr-id="' + el.getAttribute('plyr-id') + '"]', {
      youtube: {
        start: el.getAttribute('plyr-start') || null,
        end: el.getAttribute('plyr-end') || null
      }
    });
  })

})();
